module.exports = __webpack_public_path__ + "img/delete-black.242bd36e.svg";